import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import React from 'react'

import Notifications from '../_library/notifications/Notifications'
import IDVerificationForm from '../auth/form/IDVerificationForm'
import { isFullVerified } from '../utils/checkVerification'

@withRouter
@connect(state => {
  const { user } = state.auth

  return { user }
}, {})
export default class NewTourPage extends React.PureComponent {
  render() {
    const { user } = this.props
    const isVerified = isFullVerified(user?.verifyInfo)

    return (
      <div className="body-main">
        <Notifications />
        {this.props.children}
        {!isVerified && (
          <IDVerificationForm
            customMessages={{
              pending: 'Please verify your account to continue creating a Tour.',
              unverified: 'Please verify your account to continue creating a Tour.',
            }}
          />
        )}
      </div>
    )
  }
}
